document.addEventListener("DOMContentLoaded", () => {

    const tabs = document.querySelectorAll(".comparison-tab");
    const items = document.querySelectorAll(".comparison-item");
    const prev = document.querySelector(".prdct-compare-arrow.prev");
    const next = document.querySelector(".prdct-compare-arrow.next");

    let current = 0;

    function showSlide(index) {
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;

        current = index;

        tabs.forEach(tab => tab.classList.remove("active"));
        items.forEach(item => item.classList.remove("active"));

        tabs[current].classList.add("active");
        items[current].classList.add("active");

        // Scroll active tab into view on mobile
        if (window.innerWidth <= 768) {
            tabs[current].scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
            });
        }
    }

    tabs.forEach((tab,index)=>{

        tab.addEventListener("click",()=>{

            showSlide(index);

        });

    });

    next.addEventListener("click",()=>{

        showSlide(current+1);

    });

    prev.addEventListener("click",()=>{

        showSlide(current-1);

    });

});